import { Trigger } from '~/entities/Trigger';

type TriggerSpec = {
  name?: string;
  type?: string;
};

export const findTriggerBySpec = (
  triggers: Trigger[],
  triggerSpec?: TriggerSpec | null
): Trigger | undefined => {
  if (!triggerSpec?.name || !triggerSpec?.type) return undefined;

  return triggers.find(
    trigger =>
      trigger.jsonExample?.name === triggerSpec.name &&
      trigger.jsonExample?.type === triggerSpec.type
  );
};
